import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import SharepointTab from "../../AllEquipments/CommonFeatures/DCSTab/SharepointTab";
import { DCSProvider } from "../../AllEquipments/CommonFeatures/DCSTab/Table/DCSContext";
import TankMain from "../../AllEquipments/Tank/Main";
import MaterialRecords from "../../MaterialRecords";
import { Piping } from "../Piping/Index";
import { GeneralProvider } from "../../AllEquipments/CommonFeatures/SidePanel/GeneralContext";
import { PipingProjectsTab } from "../Piping/PipingPlantProjectsTab";
import PlantData from "./PlantData";
const createSubTabs = (reRender) => [
  {
    label: "PIP",
    // panel: (
    //   <GeneralProvider>
    //     <PipingProjectsTab />
    //   </GeneralProvider>
    // ),
  },
  {
    label: "GA",
    panel: <SharepointTab reRender={reRender} />,
  },
  {
    label: "PLM",
    panel: (
      <DCSProvider>
        <TankMain />
      </DCSProvider>
    ),
  },
  {
    label: "Spare Parts",
    panel: <MaterialRecords />,
  },
];

export default function SmartPidTab({ reRender }) {
  const [parentValue, setParentValue] = useState(0);
  const [childValue, setChildValue] = useState(0);

  const parentTabs = [
    { label: "EPCM Plant Data", subTabs: createSubTabs(reRender) },
    { label: "Modification Projects", subTabs: createSubTabs(reRender) },
    { label: "Maintenance projects", subTabs: createSubTabs(reRender) },
  ];

  const activeSubTabs = parentTabs[parentValue].subTabs;

  return (
    <Box flex={1}>
      <Tabs
        value={parentValue}
        onChange={(_, v) => {
          setParentValue(v);
          setChildValue(0);
        }}
      >
        {parentTabs.map((tab) => (
          <Tab
            key={tab.label}
            label={tab.label}
            sx={{
              minWidth: 180,
              maxWidth: 260,
              whiteSpace: "normal",
              textAlign: "center",
              py: 1,
            }}
          />
        ))}
      </Tabs>

      <PlantData />
      {/* {parentValue === 0 ? <PlantData /> (
      ) : (
        <>
          <Box mt={1}>
            <Tabs
              value={childValue}
              onChange={(_, v) => setChildValue(v)}
              sx={{ bgcolor: "white" }}
            >
              {activeSubTabs.map((tab) => (
                <Tab
                  key={tab.label}
                  label={tab.label}
                  sx={{
                    minWidth: 140,
                    maxWidth: 220,
                    whiteSpace: "normal",
                    textAlign: "center",
                    py: 1,
                  }}
                />
              ))}
            </Tabs>
          </Box>

          <Box>{activeSubTabs[childValue].panel}</Box>
        </>
      )} */}
    </Box>
  );
}
